// extracted by mini-css-extract-plugin
module.exports = {"root":"StorePdp_root__LesB0"};